import { FC } from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from '@state/reducers/Reducers';
import CountryAvailabilityComponent from './CountryAvailabilityComponent';
import { isEligiblePeriodicityForWarning } from '@utils/PeriodUtils';

const CountryAvailabilityBanner: FC = () => {
  const { periodicity, periodValue, subscribedCountries, unavailableCountriesByPeriodAndPg } = useSelector(
    (state: IRootState) => state.availabilityCountry,
  );
  const isMonthlyOrWeeklyOrCustomMonthsPeriodicity = isEligiblePeriodicityForWarning(periodicity, periodValue);
  if (!isMonthlyOrWeeklyOrCustomMonthsPeriodicity) {
    return null;
  }

  return (
    <CountryAvailabilityComponent
      subscribedCountries={subscribedCountries}
      unavailableCountriesByPeriodAndPg={unavailableCountriesByPeriodAndPg}
    />
  );
};

export default CountryAvailabilityBanner;
